export const getStudioResponse = (response) => {
  const { data } = response || {};

  const totalData = data?.totalData;
  const totalPage = data?.totalPage;
  const isDataExist = data?.isDataExist;

  const studios = data?.studios?.map((item) => {
    return {
      ...item,
      appType: item?.appType?.name || '-',
      area: item?.area?.name || '-',
      address: item?.address || '-',
      latitude: item?.latitude || '-',
      longitude: item?.longitude || '-',
      rawData: item,
    };
  });

  return { studios, totalData, totalPage, isDataExist };
};

export default getStudioResponse;
